// Shared: clip a corner overlay so it never draws over the sticky header. Works for zero-size
// elements whose corners are drawn by pseudo-elements: the clip is a huge polygon whose top edge
// sits exactly on the header's bottom line, in the element's own coordinates.
window.xoHeaderClip = (el, target) => {
  const head = document.querySelector('.xo-header-grid');
  const dialogOpen = document.querySelector('dialog[open]');
  if (!head || dialogOpen || (target && target.closest && target.closest('.xo-header-grid'))) { el.style.clipPath = ''; return; }
  const hb = head.getBoundingClientRect().bottom;
  if (hb <= 0) { el.style.clipPath = ''; return; }
  const cutY = Math.round(hb - el.getBoundingClientRect().top);
  el.style.clipPath = `polygon(-5000px ${cutY}px, 5000px ${cutY}px, 5000px 5000px, -5000px 5000px)`;
};
// Brand cursor (mouse / trackpad only): a neon square dot plus a bracket frame that follows
// with easing, opens wider over links and buttons, and tightens on click.
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const dot = document.createElement('div');
  const frame = document.createElement('div');
  dot.className = 'xo-cursor-dot';
  frame.className = 'xo-cursor-frame';
  dot.setAttribute('aria-hidden', 'true');
  frame.setAttribute('aria-hidden', 'true');

  const mount = () => {
    document.body.append(frame, dot);
    document.documentElement.classList.add('xo-has-cursor');
  };
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  // Keep the cursor above modal dialogs (cart drawer, menu, search): those sit in the browser's
  // top layer, so the cursor is a manual popover re-raised every time a dialog opens.
  const canPopover = typeof HTMLElement.prototype.showPopover === 'function';
  const raise = () => {
    if (!canPopover) return;
    for (const el of [frame, dot]) {
      try { if (el.matches(':popover-open')) el.hidePopover(); el.showPopover(); } catch (e) {}
    }
  };
  if (canPopover) {
    frame.setAttribute('popover', 'manual');
    dot.setAttribute('popover', 'manual');
  }
  const watch = () => {
    raise();
    new MutationObserver((records) => {
      if (records.some((r) => r.target instanceof HTMLDialogElement && r.target.open)) requestAnimationFrame(raise);
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  };
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);

  let x = -100, y = -100, fx = -100, fy = -100, visible = false;
  const interactive = 'a, button, summary, label, select, [role="button"], [command], input[type="checkbox"], input[type="radio"]';
  const textual = 'input:not([type="checkbox"]):not([type="radio"]):not([type="range"]), textarea, [contenteditable="true"]';

  // Over images, options and brand chips the four corners lock onto the element's corners; over a
  // frameless text link (footer, policies) they spread into a line under the word.
  let snap = null;
  let snapLine = false;
  const snapOf = (el) => (window.xoSnapTarget ? window.xoSnapTarget(el) : null);

  // Chat widget (Shopify Inbox): it lives in its own shadow DOM / frame, so the page stops getting mouse moves there.
  // Hand the pointer back to the normal arrow over the chat and hide the custom dot + corners until the mouse returns.
  const chatSel = 'shopify-chat, #shopify-chat, inbox-online-store-chat, [id^="ShopifyChat"], iframe[src*="inbox"], iframe[title*="chat" i]';
  const hideCursor = () => {
    visible = false;
    snap = null;
    document.documentElement.classList.remove('xo-cursor-visible', 'xo-cursor-hover', 'xo-cursor-text', 'xo-cursor-snap', 'xo-cursor-line', 'xo-cursor-down', 'xo-cursor-small', 'xo-cursor-in-frame', 'xo-cursor-field');
    frame.style.removeProperty('--w'); frame.style.removeProperty('--h'); // back to the normal free-cursor size, not the last item's size
  };
  // Express pay buttons (PayPal etc.) are frames from another site: the page gets no mouse moves inside them.
  // When the mouse enters one, lock the corners onto the whole button and hide the dot until it comes back out.
  const html = document.documentElement;
  let payEl = null;
  const payWrapSel = '.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout';
  const payOf = (t) => {
    if (!t || t.closest('.shopify-payment-button__more-options')) return null;
    if (!t.closest(payWrapSel)) return null;
    return snapOf(t)?.el || t;
  };
  document.addEventListener('pointerover', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    const p = payOf(t);
    if (!p) return;
    payEl = p;
    visible = true;
    snap = p;
    snapLine = false;
    html.classList.add('xo-cursor-visible', 'xo-cursor-snap', 'xo-cursor-in-frame');
    html.classList.remove('xo-cursor-line', 'xo-cursor-text');
  }, { passive: true, capture: true });
  document.addEventListener('pointermove', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (t?.closest(chatSel)) { event.stopImmediatePropagation(); hideCursor(); return; }
    if (payEl && !(t && t.closest(payWrapSel) && !t.closest('.shopify-payment-button__more-options'))) { payEl = null; html.classList.remove('xo-cursor-in-frame'); }
  }, { passive: true, capture: true });
  document.addEventListener('mouseout', (event) => {
    const to = event.relatedTarget instanceof Element ? event.relatedTarget : null;
    if (to?.closest(chatSel)) { hideCursor(); return; } // moving straight into the chat window (its frame sits inside the chat element)
    if (!to && !payEl) hideCursor();
  }, { passive: true });
  document.addEventListener('pointerover', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (t?.closest(chatSel)) hideCursor();
  }, { passive: true, capture: true });
  window.addEventListener('blur', () => { if (!payEl) hideCursor(); });

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse') return;
    x = event.clientX; y = event.clientY;
    if (!visible) { fx = x; fy = y; visible = true; document.documentElement.classList.add('xo-cursor-visible'); }
    const target = event.target instanceof Element ? event.target : null;
    document.documentElement.classList.toggle('xo-cursor-hover', !!target?.closest(interactive));
    // text boxes keep the site cursor (corners lock onto the box), except the quick-search panel field:
    // there the site cursor hides and the normal typing cursor shows
    document.documentElement.classList.toggle('xo-cursor-text', !!target?.closest('#predictive-search input'));
    // over a text box the centre dot hides and the green typing cursor takes its place (corners stay on the box)
    document.documentElement.classList.toggle('xo-cursor-field', !!target?.closest(textual));
    const info = snapOf(target);
    const next = info ? info.el : null;
    if (next !== snap) {
      snap = next;
      snapLine = !!info?.line;
      document.documentElement.classList.toggle('xo-cursor-snap', !!snap);
      document.documentElement.classList.toggle('xo-cursor-line', !!snap && snapLine);
      if (!snap) { frame.style.removeProperty('--w'); frame.style.removeProperty('--h'); document.documentElement.classList.remove('xo-cursor-small'); }
    }
  }, { passive: true });

  document.addEventListener('pointerdown', () => document.documentElement.classList.add('xo-cursor-down'));
  document.addEventListener('pointerup', () => document.documentElement.classList.remove('xo-cursor-down'));
  document.documentElement.addEventListener('mouseleave', () => { visible = false; document.documentElement.classList.remove('xo-cursor-visible'); });

  let markedSnap = null; // the element the corners sit on gets data-xo-snapped (its own selected-corners hide)
  let snapSeenFor = null;
  const CHOSEN = 'button[data-thumb][data-active], .xo-brand-chip.is-active, input:checked + span, [aria-current="true"][data-thumb]';
  let lastT = performance.now();
  // Only the part of an item that is actually visible: items in a sideways-scrolling row (search
  // suggestions, brand strip) can be half outside their frame, and the corners must stop at its edge.
  const visRect = (el) => {
    const b = el.getBoundingClientRect();
    let l = b.left, t = b.top, r = b.right, btm = b.bottom, clipped = false;
    for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      const cs = getComputedStyle(p);
      if (cs.overflowX === 'visible' && cs.overflowY === 'visible') continue;
      const pr = p.getBoundingClientRect();
      if (cs.overflowX !== 'visible') { if (pr.left > l) { l = pr.left; clipped = true; } if (pr.right < r) { r = pr.right; clipped = true; } }
      if (cs.overflowY !== 'visible') { if (pr.top > t) { t = pr.top; clipped = true; } if (pr.bottom < btm) { btm = pr.bottom; clipped = true; } }
    }
    return { left: l, top: t, width: Math.max(0, r - l), height: Math.max(0, btm - t), clipped };
  };
  const tick = (now = performance.now()) => {
    const dt = Math.min(64, now - lastT); lastT = now;
    // same glide on every screen (60Hz or 120Hz); a softer, slower glide while locked onto an item
    const k = 1 - Math.pow(1 - (snap ? 0.12 : 0.2), dt / 16.67);
    // (marking happens below, once the flying corners have landed on the item)
    let tx = x, ty = y;
    if (snap && !snap.isConnected) {
      // options re-render on change: lock onto the new element under the mouse
      const info = snapOf(document.elementFromPoint(x, y));
      snap = info ? info.el : null;
      snapLine = !!info?.line;
      document.documentElement.classList.toggle('xo-cursor-snap', !!snap);
      document.documentElement.classList.toggle('xo-cursor-line', !!snap && snapLine);
      if (!snap) { frame.style.removeProperty('--w'); frame.style.removeProperty('--h'); document.documentElement.classList.remove('xo-cursor-small'); }
    }
    if (snap && window.xoSnapSeen && !window.xoSnapSeen(snap)) { snap = null; payEl = null; document.documentElement.classList.remove("xo-cursor-snap", "xo-cursor-line", "xo-cursor-in-frame", "xo-cursor-small"); frame.style.removeProperty("--w"); frame.style.removeProperty("--h"); } // released when the item fades away
    if (snap && snap.isConnected) {
      const r = visRect(snap);
      tx = r.left + r.width / 2;
      ty = r.top + r.height / 2;
      const small = !snapLine && Math.min(r.width, r.height) < 30;
      let pad = snapLine ? 0 : small ? 8 : 10;
      if (r.clipped) pad = 0; // half-hidden item: corners sit on the visible part, never past the frame
      // chosen item: the mouse corners sit exactly where its own corners are
      if (!snapLine && snap === markedSnap) { const top = parseFloat(getComputedStyle(snap, '::after').top); if (!Number.isNaN(top)) pad = -2 * top; }
      frame.style.setProperty('--w', `${r.width + pad}px`);
      frame.style.setProperty('--h', `${r.height + (snapLine ? 4 : pad)}px`);
      document.documentElement.classList.toggle('xo-cursor-small', small);
    }
    fx += (tx - fx) * k;
    fy += (ty - fy) * k;
    // A chosen item (selected option, swatch, thumbnail, brand chip): its own corners become the mouse
    // corners on the spot (no fly-in, nothing disappears). When the mouse leaves, those corners travel
    // back to the mouse while the item's own corners fade back in.
    if (snap !== snapSeenFor) {
      snapSeenFor = snap;
      const chosen = snap && snap.matches(CHOSEN);
      const mark = chosen ? snap : null;
      if (mark !== markedSnap) { markedSnap?.removeAttribute('data-xo-snapped'); if (mark) mark.setAttribute('data-xo-snapped', ''); markedSnap = mark; }
      // options re-render on every choice: make sure no other copy keeps its corners hidden
      document.querySelectorAll('[data-xo-snapped]').forEach((n) => { if (n !== mark) n.removeAttribute('data-xo-snapped'); });
    }
    dot.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    frame.style.transform = `translate3d(${fx}px, ${fy}px, 0)`;
    // Free cursor floats above everything; only corners locked onto a page item tuck under the header.
    if (snap) window.xoHeaderClip(frame, snap); else frame.style.clipPath = '';
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
})();

// Browser pop-ups that sit over the page (e.g. Chrome's "App installed" box, permission prompts) kept the
// page's hidden-cursor rule, so the normal mouse pointer vanished over them. Whenever the mouse leaves the
// page or the window loses focus, the normal pointer comes back; it switches to the site cursor again as
// soon as the mouse moves over the page.
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const html = document.documentElement;
  const native = () => html.classList.remove('xo-has-cursor');
  const site = (e) => { if (e.pointerType === 'mouse' && document.hasFocus() && document.body.contains(document.querySelector('.xo-cursor-dot'))) html.classList.add('xo-has-cursor'); };
  window.addEventListener('blur', native);
  window.addEventListener('appinstalled', native);
  document.addEventListener('mouseout', (e) => { if (!e.relatedTarget) native(); }, { passive: true });
  html.addEventListener('mouseleave', native);
  document.addEventListener('pointermove', site, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) native(); });
})();

// Full-screen video: bring the site cursor back on top of the full-screen layer.
(() => {
  const reraise = () => requestAnimationFrame(() => {
    for (const el of document.querySelectorAll('.xo-cursor-frame[popover], .xo-cursor-dot[popover]')) {
      try { if (el.matches(':popover-open')) el.hidePopover(); el.showPopover(); } catch (e) {}
    }
  });
  document.addEventListener('fullscreenchange', reraise);
  document.addEventListener('webkitfullscreenchange', reraise);
})();
